import { PurchaseOrderPayloadTracking } from "./PurchaseOrderPayloadTracking";
import { Tracking } from "./Tracking";
export const CheckoutTracking = {
    beginCheckout,
};
function beginCheckout(orderLines) {
    const items = orderLines.map((orderLine) => {
        var _a, _b, _c;
        return ({
            name: orderLine.name,
            price: (_a = orderLine.unitPrice) !== null && _a !== void 0 ? _a : 0,
            quantity: orderLine.quantity,
            category: (_b = orderLine.parts[0].categoryName) !== null && _b !== void 0 ? _b : "",
            list: (_c = PurchaseOrderPayloadTracking.trackingData.get(orderLine.trackingId)) !== null && _c !== void 0 ? _c : null,
        });
    });
    Tracking.trackEvent({ tag: "BeginCheckout", contents: { items } });
}
